import React, { useState, useEffect } from "react";
import { FaUserCircle, FaStar } from "react-icons/fa";
import { motion } from "framer-motion";
import SectionHeader from "../../components/ui/HeaderSection";

const testimonials = [
  {
    name: "Nico",
    package: "Premium Package",
    rating: 5,
    comment:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  },
  {
    name: "Alice",
    package: "Basic Package",
    rating: 4,
    comment:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  },
  {
    name: "John",
    package: "VIP Package",
    rating: 5,
    comment:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  },
  {
    name: "Emma",
    package: "Basic Package",
    rating: 4,
    comment:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  },
];

const TestimonialSection = () => {
  const [duration, setDuration] = useState(25); // Default desktop

  // Function untuk update duration berdasarkan lebar layar
  useEffect(() => {
    const updateDuration = () => {
      const newDuration = window.innerWidth < 768 ? 15 : 25;
      console.log("Window Width:", window.innerWidth); // Debug ukuran layar
      console.log("Setting Duration to:", newDuration); // Debug nilai duration
      setDuration(newDuration);
    };

    updateDuration(); // Jalankan sekali saat pertama kali render
    window.addEventListener("resize", updateDuration); // Tambahkan event listener

    return () => {
      console.log("Removing event listener"); // Debug saat cleanup
      window.removeEventListener("resize", updateDuration);
    };
  }, []);

  return (
    <section
      id="testimonial-section"
      className="bg-[#F5F5F5] py-16 px-6 md:px-10"
    >
      {/* Header */}
      <div className="max-w-2xl mx-auto text-center">
        <div data-aos="fade-up" data-aos-duration="1000">
          <SectionHeader
            title="Testimonial"
            description="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            TitleColor="#EC7C65"
            DescriptionColor="#ABABAB"
          />
        </div>
      </div>
      {/* Testimonial Slider */}
      <div className="overflow-hidden mt-12 relative">
        <motion.div
          className="flex space-x-10 p-6"
          animate={{ x: ["0%", "-100%"] }}
          transition={{
            repeat: Infinity,
            duration: duration, // Dynamic duration berdasarkan state
            ease: "linear",
          }}
        >
          {testimonials.concat(testimonials).map((testimonial, index) => (
            <div
              key={index}
              className="min-w-[500px] md:min-w-[450px] bg-white p-6 rounded-lg shadow-md border-l-4 border-[#EC7C65] flex flex-col items-start"
            >
              {/* Row: Profile Icon + Name + Package */}
              <div className="flex items-center mb-3">
                <FaUserCircle className="text-6xl text-gray-500 mr-4" />
                <div>
                  <h3 className="text-lg font-semibold text-gray-700">
                    {testimonial.name}
                  </h3>
                  <p className="text-sm text-gray-500">{testimonial.package}</p>
                </div>
              </div>

              {/* Rating */}
              <div className="flex mb-2">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <FaStar key={i} className="text-yellow-400 text-lg mr-1" />
                ))}
              </div>

              {/* Comment */}
              <p className="text-sm text-gray-600">{testimonial.comment}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialSection;
